export const testPrioritizationModalConfig = {
  testCaseSourceCodeMapping: [
    {
      name: "User Story ID",
      mapping: "userStoryId",
    },
    {
      name: "User Story Description",
      mapping: "userStoryDescription",
    },
    {
      name: "Test Case ID",
      mapping: "testCaseID",
    },
    {
      name: "Acceptance Criteria",
      mapping: "acceptanceCriteria",
    },
    {
      name: "Test Case Title",
      mapping: "testScenario",
    },
    {
      name: "Pre-condition",
      mapping: "preCondition",
    },
    {
      name: "Steps",
      mapping: "steps",
    },
    {
      name: "Expected Results",
      mapping: "expectedResults",
    },
    {
      name: "Source Code Path",
      mapping: "sourceCodePath",
    },
    {
      name: "Code Snippets",
      mapping: "codeSnippets",
      type: "code-snippet",
    },
    {
      name: 'Method Name',
      mapping: "methodName"
    }
  ],
  impctedTestCaseMapping: [
    {
      name: "User Story ID",
      mapping: "userStoryId",
    },
    {
      name: "User Story Description",
      mapping: "userStoryDescription",
    },
    {
      name: "Test Case ID",
      mapping: "testcaseid",
    },
    {
      name: "Acceptance Criteria",
      mapping: "acceptanceCriteria",
    },
    {
      name: "Test Case Title",
      mapping: "testScenario",
    },
    {
      name: "Pre-condition",
      mapping: "pre_condition",
    },
    {
      name: "Steps",
      mapping: "steps",
    },
    {
      name: "Expected Results",
      mapping: "expectedResults",
    },
    {
      name: "Source Code Path",
      mapping: "sourcecodepath",
    },
    {
      name: "Code Snippets",
      mapping: "codesnippets",
      type: "code-snippet",
    },
    {
      name: 'Method Name',
      mapping: "methodname"
    }
  ],
};

export const testCaseGenerator = {
  generatedTestCasesMapping: [
    {
      name: "Test Case ID",
      mapping: "testCaseId",
    },
    {
      name: "Test Case Title",
      mapping: "testCase",
    },
    {
      name: "Test Case",
      mapping: "testScenario",
    },
    {
      name: "Expected Results",
      mapping: "expectedResult",
    },
    {
      name: "Story Description",
      mapping: "storydesc",
    },
    {
      name: "Story Summary",
      mapping: "storysummary",
    },
  ],
};
